import { types } from 'mobx-state-tree'

export const SupplierPhysicalRegionsModel = types.model('SupplierPhysicalRegionsModel', {
  physicalRegionCode: types.number,
  name: types.string,
})
